export enum ValidationMessage {
  NON_EMPTY = "Fältet måste fyllas i.",
  EMAIL = "Fältet måste innehålla en gilitg e-post.",
  REPEATED_PASSWORD = "Fältet matchar inte lösenordet.",
  URL = "Fältet måste innehålla en giltig url.",
  CAPTCHA = "Captchan måste lösas.",
}

export const ValidationMessageFunction = {
  MIN: (minValue: number) => `Fältet får innehålla minst ${minValue} tecken.`,
  MAX: (maxValue: number) => `Fältet får innehålla max ${maxValue} tecken.`,
};
